import { Injectable } from '@angular/core';

import { BehaviorSubject } from 'rxjs';

import { DpUrlService } from '@app/core/services/url.service';

@Injectable({ providedIn: 'root' })
export class DpSearchService {
  private readonly termValue$ = new BehaviorSubject('');

  constructor(private readonly dpUrlService: DpUrlService) {
    const urlTerm = this.dpUrlService.getSearchTerm();

    this.termValue$.next(urlTerm ?? '');
  }

  escapeQuery(query: string): string {
    const currentTerm = this.termValue$.getValue();

    if (currentTerm) {
      const escapedTerm = this.escapeTerm(currentTerm);

      return query.replace(currentTerm, escapedTerm);
    }

    return query;
  }

  escapeTerm(term: string): string {
    return term.replaceAll(':', '\\_\\');
  }

  setTerm(value: string): void {
    this.termValue$.next(value);
  }
}
